import { z } from 'zod';
import { LOCALES } from '../locales.js';
import { PRODUCT_IDS } from '../products.js';

export const objectIdSchema = z.string().regex(/^[0-9a-f]{24}$/, 'invalid_id');

export const localeSchema = z.enum(LOCALES);

export const productIdSchema = z.enum(PRODUCT_IDS);

const supportedTimeZones = new Set(Intl.supportedValuesOf('timeZone'));
export const timeZoneSchema = z
  .string()
  .refine((tz) => supportedTimeZones.has(tz) || tz === 'UTC', 'invalid_timezone');

/** Public handle used in booking URLs: /:username */
export const usernameSchema = z
  .string()
  .trim()
  .toLowerCase()
  .regex(/^[a-z0-9](?:[a-z0-9-]{1,28}[a-z0-9])?$/, 'invalid_username');

export const slugSchema = z
  .string()
  .trim()
  .toLowerCase()
  .regex(/^[a-z0-9](?:[a-z0-9-]{0,58}[a-z0-9])?$/, 'invalid_slug');

export const emailSchema = z.string().trim().toLowerCase().email().max(254);

export const apiErrorSchema = z.object({
  code: z.string(),
  message: z.string(),
  details: z.unknown().optional(),
});
export type ApiError = z.infer<typeof apiErrorSchema>;
